export const displayMessage = {
  default: {
    noResults: "Uh oh! We couldn't find any results for you.",
    internalError: 'An internal error occurred. Please try again later.',
    emptyFilterResults: 'Try adjusting your filters to see more results.',
  },
  sentry: {
    error: 'Failed to load Sentry issues',
    empty: 'No Sentry issues found',
    errorSubtext: 'Please ensure you are logged in and have access to the Sentry API',
    emptySubtext: 'There are currently no issues to display',
  },
  cloudWatch: {
    error: 'Failed to load CloudWatch Error logs',
    empty: 'No CloudWatch Error logs found',
    errorSubtext: 'Please ensure you are logged in and have access to CloudWatch',
    emptySubtext: 'There are currently no Error logs to display',
  },
}

export const toastMessage = {
  generics: {
    error: 'An error occurred. Please try again.',
    success: 'Operation completed successfully.',
    failedToLoadData: 'Failed to load data',
    failedToLoadDataSubtext: 'Please try again later or contact support if the problem persists.',
  },
  sentry: {
    exportSuccess: 'Issues exported successfully.',
    exportError: 'Failed to export issues. Please try again.',
  },
  login: {
    completingSignIn: 'Completing sign in...',
    loading: 'Loading...',
  },
}
